export default __webpack_public_path__ + "static/media/study_small.d8df4b06.png";